<template>
	<div>

		<van-nav-bar title="续费" left-text="返回" left-arrow fixed placeholder @click-left="goBack" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />

		<div class="page page-3">
			<div class="s1">
				<div class="b1">
					<div class="p1">
						续费
					</div>
					<div class="p2">
						{{group_info.nickname}}
					</div>
				</div>
			</div>
			<div class="s2">
				<div class="b2" style="flex-wrap: wrap;">
					<div class="item" v-for="(item, index) in list" :key="item.id" :style="{marginBottom: (index==list.length-1 || index==list.length-2) ? '0' : '0.15rem'}">
						<div class="wrap" :class="select_index==index?'active':''" @click="selectProduct(index)">
							<div class="p1">
								{{item.title}}
								<small>
									/{{item.day}}天
								</small>
							</div>
							<div class="p2">
								<small>
									￥
								</small>
								{{item.price}}
							</div>
							<div class="p3">
								{{item.des}}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="s5">
				<div class="wrap">
					<div class="divider">
					</div>
					<div class="flex h-between">
						<div class="flex flex-1 px-3">
							<div>
								<b>
									需支付：
								</b>
							</div>
							<div>
								<b style="color: rgb(244, 71, 51);">
									￥{{price}}
								</b>
							</div>
						</div>
						<div>
							<a href="javascript:void(0)" class="btn-cus" @click="buyInfo">
								马上续费
							</a>
						</div>
					</div>
				</div>
			</div>



			<van-popup v-if="list.length>0" v-model="show_buy_info" round position="bottom" :style="{ height: buy_info_height}">
				<div style="padding: 1em;">
					<div style="height: 2.2em;border-bottom: 1px solid #EBEDF0;margin-bottom: .5em;">
						<van-checkbox v-model="checked" :style="{float: 'left'}">我已阅读并同意</van-checkbox>
						<div style="color: #288CFA;display: inline;float: left;" @click="showArgeement">《购买协议》</div>
					</div>
					<div class="buy-info">
						<div class="info-0">
							<div class="info-0-title">续费版本：</div>
							<div>{{list[select_index].title}}</div>
						</div>
					</div>
					<div style="margin-top: 1em;">
						<van-button type="primary" :disabled="!checked" color="#288CFA" block @click="confirmBuy">确认续费</van-button>
					</div>

				</div>
			</van-popup>
			<van-dialog v-if="list.length>0" v-model="show_argeement" title="购买协议">
				<div style="padding: 1em;font-size: 12px;">
					<p>1、本产品为{{list[select_index].title}}，开通后可使用{{list[select_index].day}}天。开通后将与群绑定。</p>
					<p>2、购买1个，可管理1个群，多个群管理需购买多个权限。</p>
					<p>3、本产品因特殊性，购买后不支持退款。如出现操作使用及其他问题，可前往微信公众号咨询客服。</p>
					<p>4、严禁利用本产品参与赌博、传销、色情等一切违法活动以及散布法律禁止的内容信息。一经发现，本公司有权无条件收回助手使用权。</p>
					<br>
					<p>友情提示：</p>
					<p>使用本产品前请严格遵守《腾讯微信软件许可及服务协议》，本产品仅为用户提供针对社群运营管理提供方便，无法完全避免频繁操作造成的强制掉线、封号等问题，请在使用过程中根据运营经验自行把控风险。</p>
				</div>
			</van-dialog>
		</div>
	</div>

</template>

<script>
	import Vue from 'vue';
	import {
		Popup,
		Checkbox,
		NavBar,
		Button
	} from 'vant';

	Vue.use(Popup);
	Vue.use(Checkbox);
	Vue.use(Button);
	Vue.use(NavBar);
	export default {
		data() {
			return {
				list: [],
				select_index: 0,
				price: 0,
				show_buy_info: false,
				show_argeement: false,
				checked: true,
				buy_info_height: window.innerHeight - 1000 + 'em',
				group_id: 0,
				group_info: {}
			}
		},
		created() {
			var select_id = this.$route.params.id

			this.group_id = select_id
			this.$ApiUtil.GroupCenter.get({
				id: select_id
			}).then(res => {
				if (!res.status) {
					this.$dialog.alert({
						message: '请稍后再试'
					}).then(() => {
						this.$router.push('/member-center')
					})
					return
				}
				this.group_info = res.data
			})
			this.$ApiUtil.Buy.getProduct().then(res => {
				this.list = res.list, this.selectProduct(0)
			})

		},
		methods: {
			showArgeement() {
				this.show_argeement = true
			},
			buyInfo() {
				this.show_buy_info = true
			},
			selectProduct(index) {
				this.select_index = index
				this.price = this.list[index].price
			},
			confirmBuy() {
				this.show_buy_info = false
				if (this.select_index < 0) {
					this.$toast.fail('请选择续费时长')
					return;
				}
				var product_id = this.list[this.select_index].id
				this.$ApiUtil.Order.createOrder({
					product_id: product_id,
					resur_id: this.group_id
				}).then(res => {

					// if(!res.status){
					// 	this.$toast.fail(res.message)
					// 	return;
					// }
					// this.weixinPay(res.pay_info)

					if (res.status == 0) {
						this.$toast.fail(res.message)
						return
					} else {

						if (typeof res.url !== 'undefined') {
							var url = encodeURIComponent(res.url)
							var order_sn = res.order_sn
							var str = JSON.stringify({
								url: url,
								sn: order_sn
							})
							this.$router.push(`/pay-${str}`)
						}
					}
				})

			},
			weixinPay(data) {
				if (typeof WeixinJSBridge == "undefined") { //微信浏览器内置对象。参考微信官方文档
					if (document.addEventListener) {
						document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data), false);
					} else if (document.attachEvent) {
						document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data));
						document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data));
					}
				} else {
					this.onBridgeReady(data);
				}
			},
			onBridgeReady(data) {
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', JSON.parse(data),
					res => {
						if (res.err_msg == "get_brand_wcpay_request:ok") {
							this.$router.push('/member-center')
						}
					}
				);
			},
			goBack() {
				this.$router.push('/member-center')
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/style.css");
	@import url("../../assets/buy-intro-v4.css");

	.buy-info {
		display: flex;
		flex-direction: column;
	}

	.info-0 {
		display: flex;
		justify-content: space-between;
		margin: .5em;
		font-size: 12px;
	}

	.info-0 div {
		color: #288CFA;
	}

	.info-0 .info-0-title {
		color: #000000;
		font-weight: bold;
	}

	.s1 .b1 {
		background: url(../../assets/icon-1.png);
	}
</style>
